import { forwardRef, ForwardedRef } from 'react';

import { ContainerOptions, RowColumnProps, resolveClasses } from './config';

export type RowProps<As extends ContainerOptions = 'div'> = RowColumnProps<As>;

const RowBase = <As extends ContainerOptions = 'div'>(
  {
    children,
    as,
    title,
    onSubmit,
    gap = '4',
    alignItems = 'center',
    styles,
    ...styleConfig
  }: RowProps<As>,
  ref: ForwardedRef<HTMLElement>,
) => {
  const Comp = as || 'div';

  return (
    <Comp
      className={resolveClasses({ alignItems, gap, ...styleConfig })}
      title={title}
      ref={ref as never}
      onSubmit={onSubmit}
      style={styles}
    >
      {children}
    </Comp>
  );
};

export const Row = forwardRef(RowBase);
